import React, { FC } from 'react';
import { Box, Text, TextFieldSize, FormControl } from '@bechtel/gds';
import { useField } from 'formik';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { TextAreaStyled } from './styled';
import { CommentProps } from './types';

export const Comment: FC<CommentProps> = ({ name }) => {
  const [field, meta] = useField(name);

  return (
    <Box
      px={{ sm: '450' }}
      pt={{ sm: '600' }}
      pb={{ sm: '500' }}
      flexDirection={{ sm: 'column' }}
      data-testid="reason-comment-container"
    >
      <FormControl label={t`Please Specify`} data-testid="form-control">
        <TextAreaStyled maxLength={2000} {...field} size={TextFieldSize.LARGE} rows="4" />
      </FormControl>
      {meta.touched && meta.error ? <ErrorField error={meta.error} /> : null}
    </Box>
  );
};

const ErrorField = ({ error }) => {
  const { i18n } = useLingui();
  return (
    <Box pt={{ sm: '200' }}>
      <Text color="bechtel.red">{i18n._(error)}</Text>
    </Box>
  );
};
